import { render, staticRenderFns } from "./tradeLeads.vue?vue&type=template&id=78fb946c&scoped=true&"
import script from "./tradeLeads.vue?vue&type=script&lang=js&"
export * from "./tradeLeads.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeads.vue?vue&type=style&index=0&id=78fb946c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb946c",
  null
  
)

export default component.exports